$(document).ready(function(){
var left_arrow = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 7 11"><path d="M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z" fill="#fff" class="layer"/></svg>';
var right_arrow = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 7 11"><path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff"/></svg>';
  
  $('.pro-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide:'li',
     responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 512,
      settings: {
        slidesToShow: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
  $('.site-nav>ul>li , .site-nav>li').on('mouseover',function(e){    
    $('.site-nav>ul>li[data-has-dropdowns]').removeClass('site-nav--active-dropdown')
    $('.site-nav>ul>li[data-has-dropdowns]').attr('aria-expanded',false);
    $('.site-nav>li[data-has-dropdowns]').removeClass('site-nav--active-dropdown')
    $('.site-nav>li[data-has-dropdowns]').attr('aria-expanded',false);
    var attr = $(this).attr('data-has-dropdowns');
    var attr_class = $(this).hasClass('site-nav--active-dropdown');
    var attr_ = $(this).find('[type="button"]').attr('aria-expanded');
    // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
    if (typeof attr !== typeof undefined && attr !== false && attr_class == false) {
      $(this).addClass('site-nav--active-dropdown')
      $(this).find('[type="button"]').attr('aria-expanded',true);
    }else
    {
      if (typeof attr == typeof undefined) {
        $(this).parent().find('.site-nav--has-dropdown').removeClass('site-nav--active-dropdown')
        $(this).parent().find('[type="button"]').attr('aria-expanded',false);
        console.log("else "+attr_+"  "+attr);
      }
    }
  });
  
  $('.site-header').on('mouseleave',function(e){
    $(this).find('.site-nav--has-dropdown').removeClass('site-nav--active-dropdown')
    $(this).find('[type="button"]').attr('aria-expanded',false);
  }); 
  
  $('body').on('click',function(e){
    var temp = $(this).find('.site-nav--active-dropdown');
    var attr = temp.attr('data-has-dropdowns');
      temp.find('[type="button"]').attr('aria-expanded',false);
      temp.removeClass('site-nav--active-dropdown')
  });
  
  
  var equpbox_height = $('.image_box_eqip figure').width();
  $('.image_box_eqip figure').css("height", equpbox_height + "px");
  
  $('.open_equip').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    image: {
      verticalFit: false
    }
  });
  
  
  $(document).on('click','.modal_popup',function(e){
  	e.preventDefault();
  	var oldUrl = $(this).attr("href"); // Get current url
    var newUrl = oldUrl.replace("#", ""); // Create new url
    console.log(newUrl);
      $('.modal').each(function(index){
        $(this).removeClass('modal--is-active');
      })      
    $('body').find(oldUrl).addClass('modal--is-active');
    var handle = $(this).data('handle');
    console.log(typeof handle);
    
    if(typeof handle !== typeof undefined )
    {
      jQuery.getJSON('/products/'+ handle +'.js', function(product) {
        console.log('The title of this product is ' + product.title);
        console.log(product);
        $('#RequestPriceForm').find('textarea').val('Product Name = '+product.title );
        $('#RequestPriceForm').find('.form_pro_url').val(product.url);
        $('#RequestPriceForm').find('.form_pro_title').val(product.title);
        
      } );
    }
  });
  
  $(document).on('click','.modal__close',function(e){
  	var parent = $(this).parents('.modal');
    if( parent.hasClass('modal--is-active') )
    {
    	parent.removeClass('modal--is-active');
    }
      
  });
  
  $(document).on('click','.level_wrapper .icon',function(e){
    console.log($(this).parent());
    console.log($(this).parent().next());
    var parent_ = $(this).parent();
    var next_child = parent_.next();
    if( parent_.parent().hasClass('active') ){
      parent_.next().slideUp()
      parent_.next().removeClass('ul_active');
      parent_.parent().removeClass('active');
    }
    else{
      next_child.slideDown();
      parent_.next().addClass('ul_active');
      parent_.parent().addClass('active');
    }
    
  });
  
  
  $('.lang-select').click(function() {
    var theLang = $(this).attr('data-lang');
    /*if( theLang == 'en' )
    {
      	document.cookie = "googtrans=/en/en,expires=N/A; path=/";      
        //$.cookie("googtrans", "/en/en", "/", "https://dragon-brand.myshopify.com");
        //$.cookie("googtrans", "/en/en", "/", "https://dragon-brand.myshopify.com");           
    }
    else
    {
    	document.cookie = "googtrans=/en/zh-CN,expires=N/A; path=/";      
    }*/
    //alert(jQuery(this).attr('href'));
    $('.goog-te-combo').val(theLang);
    //window.location = $(this).attr('href');
    //console.log(window.location );
    //location.reload();
    var flag = 0;
    
    $('#google_translate_element select option').each(function(){
      if($(this).attr('value') == theLang ) {
        console.log($(this).attr('value'));
        $(this).parent().val($(this).val());
        var container = document.getElementById('google_translate_element');
        var select = container.getElementsByTagName('select')[0];
        triggerHtmlEvent(select, 'change');
        flag = 1 ;
      }
      
      
    });
    
    if( flag == 1 )
    {
      setTimeout(function(){
         location.reload();
      },1000)
    }
    

  });
  
  function triggerHtmlEvent(element, eventName) {

    var event;
    if (document.createEvent) {
      event = document.createEvent('HTMLEvents');
      event.initEvent(eventName, true, true);
      element.dispatchEvent(event);
    } else {
      event = document.createEventObject();
      event.eventType = eventName;
      element.fireEvent('on' + event.eventType, event);
    }
  }  
  
  $('.tabs-nav a').on('click', function (event) {
    event.preventDefault();
    $('.tab-active').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tab-content').hide();
    $('.tabs-stage .tab-content').removeClass("current-tab");
    $($(this).attr('href')).show();
    $($(this).attr('href')).addClass("current-tab");
  });
  
//   $(document).on('click','.site-header__cart',function(e){
//     e.preventDefault();
//   })
  
  $(document).on('mouseover , click','.site-header__cart',function(e){
  	$(this).parent().find('.cart-popup').addClass("cart-popup-open");
  })
  
  $(document).on('click','.cart-popup .icon_close',function(e){
  	$(this).parents('.cart-popup').removeClass("cart-popup-open");
  })
  
  
  $(document).on('click','.product-single__photo-wrapper.js .zoomImg',function(e){
    console.log('clicked');
    $(this).toggleClass('zooming');
  
  });
  
});

$slickGreen = false;
function greenSlider(){    
  if($(window).width() < 1200){
    if(!$slickGreen){
      $(".feature_img_bar").slick({
        dots: false,
        arrows: true,
        infinite:false,
        slidesToShow: 3,
        slidesToScroll: 1,
     	responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      $slickGreen = true;
    }
  } else if($(window).width() >= 1200){
    if($slickGreen){
      $('.feature_img_bar').slick('unslick');
      $slickGreen = false;
    }
  }
};

$Myslick = false;
$slick_related = false;
function MySlider(){    
  if($(window).width() < 640){
    if(!$Myslick){
      $(".my_coll").slick({
        dots: false,
        arrows: true,
        infinite:false,
        slidesToShow: 1,
        slidesToScroll: 1
     });
      $Myslick = true;
    }
  } else if($(window).width() >= 640){
    if($Myslick){
      $('.my_coll').slick('unslick');
      $Myslick = false;
    }
  }
  
  
    if($(window).width() < 769){
      if(!$slick_related){
        $(".related_slider").slick({
          dots: false,
          arrows: true,
          infinite:false,
          slidesToShow: 2,
          slidesToScroll: 1,
           responsive: [
             {
               breakpoint: 500,
               settings: {
                 slidesToShow: 1
               }
             }
		   ]
        });
        $slick_related = true;
      }
    } else if($(window).width() >= 769){
      if($slick_related){
        $('.related_slider').slick('unslick');
        $slick_related = false;
      }
    }
    
    
  
};

$Proslick = false;
function ProSlider(){    
  if($(window).width() < 991){
    if(!$Myslick){
      $(".pro-single_slider").slick({
        dots: false,
        arrows: true,
        infinite:false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '.thumbnails-slider__prev--product-template',
        nextArrow: '.thumbnails-slider__next--product-template',
        verticalSwiping:true,
        focusOnSelect:true,
        centerMode:true,
        vertical:true
     });
      $Proslick = true;
    }
  } else if($(window).width() >= 991){
    if($Myslick){
      $('.pro-single_slider').slick('unslick');
      $Proslick = false;
    }
  }
};

$(document).ready(function(){
  MySlider();
  greenSlider();
  ProSlider();
  if($(window).width() > 499 ){
    equalheight('.grid-view-item__image-wrapper');
  }
  else
  {
    $('.grid-view-item__image-wrapper').removeAttr('style');
  }
});
$(window).on('resize', function(){
  MySlider() 
  greenSlider();
  ProSlider();
  if($(window).width() > 499 ){
  equalheight('.grid-view-item__image-wrapper');
  }
  else
  {
     $('.grid-view-item__image-wrapper').removeAttr('style');
  }
  var equpbox_height = $('.image_box_eqip figure').width();
  $('.image_box_eqip figure').css("height", equpbox_height + "px");
});


$(window).on('load', function(){
   
  /* Get cookie for  */
  var goog = getCookie();
  setTimeout(function(){  
      var site_lang = $('html').attr('lang');
      $('.lang-select').each(function(){
        if ($(this).data('lang') == site_lang )
        {
          //console.log($(this).text());
          //console.log($(this).find('img').attr('src'));
          $('.lang_switch').find('img').attr('src',$(this).find('img').attr('src'));
          $('.lang_switch').find('span').text($(this).text());
        }
      });
    
    $('.lang-select').each(function(){
      if ($(this).data('lang') == site_lang )
      {
        //console.log($(this).text());
        //console.log($(this).find('img').attr('src'));
        $('.lang_switch').find('img').attr('src',$(this).find('img').attr('src'));
        $('.lang_switch').find('span').text($(this).text());
      }
    });  
  },100)
  
});

function getCookie(googtrans) {
    var name = "googtrans=/en/";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
        
      }
      if (c.indexOf(name) == 0) {
        console.log(c);
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

/* Equal Height */
equalheight = function(container) {
  var currentTallest = 0,currentRowStart = 0,rowDivs = new Array(),$el,topPosition = 0;
  var maxHeight = 0;
  $(container).each(function() {
    
    $el = $(this);
    $($el).css('min-height','auto');
    topPostion = $el.offset().top;
    if (currentRowStart != topPostion) {
      for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].css('min-height',currentTallest+'px');
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      console.log(topPostion)
      currentTallest = $el.height();
      rowDivs.push($el);
      console.log(currentTallest)
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest <= $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].css('min-height',currentTallest+'px');
    }
  });
  
  var top_p = 0;
  
  $(container).each(function() {
    var el = $(this)
    
    
  });
  
}


$(document).ready(function(){
  setTimeout(function(){
    var text1 = $('.dd-selected-text').html()
    if(text1 == 'Chinese'){
          console.log(text1);
      $("#AccessibleNav").addClass(text1);
    }
    
  }, 1000);
  setTimeout(function(){
    var div_ = $("#smile-ui-container").parent().css({"position": "relative", "z-index": "0"});
  }, 5000);
  
   setTimeout(function(){
    var div_ = $("#smile-ui-container").parent().addClass("abbb");
  }, 5000);
});


 
 setTimeout(function(){
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 100) {
        //clearHeader, not clearheader - caps H
        $("#smile-ui-container").parent().addClass("darkHeader");
    } else {
    $("#smile-ui-container").parent().removeClass("darkHeader");
    }
  
});}, 5100);